import Sidebar from "@/components/Sidebar";

export default function Layout({ children, title, subtitle, actions }) {
  return (
    <div className="min-h-screen flex bg-background">
      <Sidebar />
      <main className="flex-1 ml-64">
        <header className="border-b border-border sticky top-0 z-20 bg-background/80 backdrop-blur-xl">
          <div className="px-8 py-6 flex items-start justify-between gap-4">
            <div>
              {title && (
                <h1 className="text-3xl md:text-4xl font-black tracking-tighter" style={{ fontFamily: "Manrope" }}>
                  {title}
                </h1>
              )}
              {subtitle && (
                <p className="text-muted-foreground mt-1 text-sm">{subtitle}</p>
              )}
            </div>
            {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
          </div>
        </header>
        <div className="px-8 py-8">{children}</div>
      </main>
    </div>
  );
}
